(function () {
  'use strict';
  var keys = ['filter.p.m.custom.vehicle_brand', 'filter.p.m.custom.vehicle_model', 'filter.p.m.custom.model_year'];
  function values(x) { return Array.isArray(x) ? x.map(String) : x == null || x === '' ? [] : [String(x)]; }
  function modelName(brand, model) {
    var name = String(model || '').trim(), compact = name.toUpperCase().replace(/[\s-]+/g, '');
    if (brand === 'Suzuki') {
      if (/^GSXR(600|750|1000)$/.test(compact)) return 'GSX-R' + compact.slice(4);
      if (/^HAYABUSAGSX(R1300|1300R)$/.test(compact)) return 'Hayabusa GSX1300R';
    }
    if (brand === 'Yamaha' && /^YZFR(1|3|6|6S|7|9|25|125)$/.test(compact)) return 'YZF-' + compact.slice(3);
    if (brand === 'Kawasaki' && /^ZX(4|6|7|9|10|12|14)R$/.test(compact)) return 'ZX-' + compact.slice(2);
    return name;
  }
  window.NTCarbonVehicleModelName = modelName;
  function entries(record) {
    if (record.fitment && record.fitment.schema === 1 && Array.isArray(record.fitment.entries)) return record.fitment.entries;
    return values(record.models).map(function (model) { return {brand:record.brand, model:model, years:values(record.years)}; });
  }
  function matches(record, selected) {
    if (!selected.some(Boolean)) return true;
    return entries(record).some(function (entry) {
      return (!selected[0] || entry.brand === selected[0]) && (!selected[1] || modelName(entry.brand, entry.model) === modelName(selected[0] || entry.brand, selected[1])) && (!selected[2] || values(entry.years).indexOf(selected[2]) !== -1);
    });
  }
  window.NTCarbonVehicleMatch = matches;
  function init() {
    var root = document.querySelector('[data-nt-carbon-vehicle]');
    if (!root || root.dataset.carbonVehicleReady) return;
    root.dataset.carbonVehicleReady = 'true';
    var config = JSON.parse(root.querySelector('[data-nt-vehicle-text]').textContent);
    var form = root.querySelector('[data-nt-collection-filter]');
    var selects = keys.map(function (k) { return form.querySelector('select[name="' + k + '"]'); });
    var apply = form.querySelector('[data-nt-apply-filter]');
    var control = root.querySelector('[data-nt-stock-control]');
    var toggle = control && control.querySelector('[data-nt-stock-toggle]');
    var status = control ? control.querySelector('[data-nt-stock-status]') : document.createElement('p');
    if (!control) { status.setAttribute('role','status'); form.appendChild(status); }
    var grid = root.querySelector('.nt-collection-product-grid'), count = root.querySelector('[data-nt-stock-count]');
    var nativePager = root.querySelector('.nt-pagination'), pager = null;
    var currentURL = new URL(location.href), selected = keys.map(function (k) { return currentURL.searchParams.get(k) || ''; });
    selected[1] = modelName(selected[0], selected[1]);
    var activeStock = currentURL.searchParams.get('nt_stock') === '1';
    var collectionURL = new URL(root.dataset.collectionUrl, location.origin);
    var allCards = null, pendingCards = null, dictionary = {}, optionReady = false, generation = 0, page = 0;
    var requestController = new AbortController();
    var initialPage = Math.max(0,(parseInt(currentURL.searchParams.get('page'),10)||1)-1);
    function setOptions(select, placeholder, list, value) {
      select.replaceChildren(new Option(placeholder,''));
      list.sort(function(a,b){return a.localeCompare(b,undefined,{numeric:true});}).forEach(function(v){select.add(new Option(v,v));});
      if (value && list.indexOf(value) === -1) select.add(new Option(value,value));
      select.value = value || '';
    }
    function applyState() { apply.disabled = !optionReady || !selects.some(function(s){return s.value;}); }
    function setYears(value) {
      var ys = (dictionary[selects[0].value] || {})[selects[1].value] || [];
      setOptions(selects[2],selects[1].value ? config.allYears : config.chooseModel,ys.slice(),value);
      selects[2].disabled = !selects[1].value; applyState();
    }
    function setModels(model, year) {
      setOptions(selects[1],selects[0].value ? config.allModels : config.chooseBrand,Object.keys(dictionary[selects[0].value] || {}),model);
      selects[1].disabled = !selects[0].value; setYears(year);
    }
    async function fetchDocument(url) {
      var response = await fetch(url.href,{credentials:'same-origin',signal:requestController.signal});
      if (!response.ok) throw Error('HTTP ' + response.status);
      return new DOMParser().parseFromString(await response.text(),'text/html');
    }
    async function loadOptions() {
      var url = new URL(collectionURL.href), seen = new Set();
      url.searchParams.set('view','nt-vehicle-data');
      var preview = currentURL.searchParams.get('preview_theme_id'); if(preview) url.searchParams.set('preview_theme_id',preview);
      while (true) {
        if(seen.has(url.href)) throw Error('Repeated data page');seen.add(url.href);
        var doc = await fetchDocument(url), node = doc.querySelector('[data-nt-vehicle-data]');
        if(!node) throw Error('Missing vehicle data');var data = JSON.parse(node.textContent);
        data.products.forEach(function(record){entries(record).forEach(function(e){
          if(!e.brand || !e.model) return;
          var models = dictionary[e.brand] || (dictionary[e.brand]={});
          var model = modelName(e.brand, e.model);
          models[model] = Array.from(new Set((models[model] || []).concat(values(e.years))));
        });});
        if(!data.next) break;url.searchParams.set('page',String(data.next));
      }
      optionReady = true;
      setOptions(selects[0],config.allBrands,Object.keys(dictionary),selected[0]);selects[0].disabled=false;
      setModels(selected[1],selected[2]);form.removeAttribute('aria-busy');
      root.dataset.vehicleOptionsLoaded='true';
    }
    async function loadCards() {
      if (allCards) return allCards;
      if (pendingCards) return pendingCards;
      pendingCards = (async function(){
        var url = new URL(location.href), result = [], seenPages = new Set(), seenIds = new Set();
        url.searchParams.delete(keys[1]);url.searchParams.delete('page');url.searchParams.delete('nt_stock');url.searchParams.set('view','nt-vehicle-items');
        while(true){
          if(seenPages.has(url.href)) throw Error('Repeated items page');seenPages.add(url.href);
          var doc=await fetchDocument(url), feed=doc.querySelector('[data-nt-vehicle-items]');
          if(!feed) throw Error('Missing vehicle items');
          feed.querySelectorAll('.nt-product-card').forEach(function(card){
            var node=card.querySelector('[data-nt-card-vehicle]');
            if(!node) throw Error('Missing card fitment');var record=JSON.parse(node.textContent);
            if(!seenIds.has(record.id)&&matches(record,selected)){seenIds.add(record.id);result.push(document.importNode(card,true));}
          });
          if(!feed.dataset.nextPage) break;url.searchParams.set('page',feed.dataset.nextPage);
        }
        if(window.NTCarbonGroups)await window.NTCarbonGroups.readManifest();
        allCards=result;return result;
      })();
      try{return await pendingCards;}finally{pendingCards=null;}
    }
    function formsStock() {
      root.querySelectorAll('form[method="get"]').forEach(function(f){
        var field=f.querySelector('input[name="nt_stock"]');
        if(!field){field=document.createElement('input');field.type='hidden';field.name='nt_stock';field.value='1';f.appendChild(field);}
        field.disabled=!activeStock;
      });
    }
    function goToPage(target) {
      var restoreFocus = pager.contains(document.activeElement);
      page = target;renderCards(allCards);
      var url=new URL(location.href);
      if(page)url.searchParams.set('page',String(page+1));else url.searchParams.delete('page');
      history.replaceState(null,'',url.href);
      if (restoreFocus) pager.querySelector('[aria-current="page"]')?.focus({preventScroll:true});
      grid.scrollIntoView({block:'start'});
    }
    function renderPager(pages) {
      if (!pager) {
        pager = document.createElement('nav');pager.className = 'nt-pagination';
        pager.setAttribute('aria-label',config.pagination);grid.after(pager);
      }
      if (typeof window.ntRenderCollectionPager === 'function') {
        window.ntRenderCollectionPager(pager,page,pages,goToPage,config);
        return;
      }
      if (!pager.children.length) {
        var prev = document.createElement('button'), label = document.createElement('span'), next = document.createElement('button');
        prev.type = next.type = 'button';prev.textContent = '←';next.textContent = '→';
        prev.setAttribute('aria-label',config.previous);next.setAttribute('aria-label',config.next);
        label.className = 'is-current';label.tabIndex = -1;label.setAttribute('aria-current','page');
        prev.addEventListener('click',function(){goToPage(page-1);});
        next.addEventListener('click',function(){goToPage(page+1);});
        pager.append(prev,label,next);
      }
      pager.hidden = pages <= 1;pager.children[0].disabled = page === 0;
      pager.children[1].textContent = (page+1)+' / '+pages;pager.children[2].disabled = page >= pages-1;
    }
    function renderCards(cards) {
      var visible=cards.filter(function(card){return !activeStock || card.dataset.ntUsStock==='true';});
      if(window.NTCarbonGroups)visible=window.NTCarbonGroups.groupCards(visible,selected);
      var pages=Math.max(1,Math.ceil(visible.length/24));page=Math.max(0,Math.min(page,pages-1));
      grid.replaceChildren.apply(grid,visible.slice(page*24,(page+1)*24));
      if(!visible.length){var empty=document.createElement('p');empty.className='nt-empty';empty.textContent=config.noMatch;grid.appendChild(empty);}
      count.textContent=visible.length+' '+(activeStock?config.stockProducts:config.products);
      if(nativePager) nativePager.hidden=true;
      renderPager(pages);
      grid.hidden=false;grid.removeAttribute('aria-busy');root.dataset.vehicleResultsLoaded='true';
      document.dispatchEvent(new CustomEvent('nt:currency:refresh'));
    }
    async function updateResults() {
      var gen=++generation;formsStock();if(toggle)toggle.setAttribute('aria-pressed',String(activeStock));
      grid.hidden=true;grid.setAttribute('aria-busy','true');if(nativePager)nativePager.hidden=true;status.textContent=config.loading;
      try{var cards=await loadCards();if(gen!==generation)return;page=initialPage;initialPage=0;renderCards(cards);status.textContent='';}
      catch(error){if(gen!==generation)return;grid.hidden=true;status.textContent=config.error;var retry=document.createElement('button');retry.type='button';retry.textContent=config.retry;retry.addEventListener('click',updateResults,{once:true});status.appendChild(retry);}
    }
    selects[0].addEventListener('change',function(){setModels('','');});selects[1].addEventListener('change',function(){setYears('');});selects[2].addEventListener('change',applyState);
    form.addEventListener('submit',function(event){if(!optionReady){event.preventDefault();return;}selects.forEach(function(s){s.disabled=!s.value;});});
    if(toggle){toggle.hidden=false;toggle.addEventListener('click',function(){activeStock=!activeStock;var url=new URL(location.href);if(activeStock)url.searchParams.set('nt_stock','1');else url.searchParams.delete('nt_stock');history.replaceState(null,'',url.href);updateResults();});}
    root.addEventListener('click',function(event){if(!activeStock)return;var a=event.target.closest('a[href]');if(!a)return;var u=new URL(a.href,location.href);if(u.origin===location.origin&&u.pathname===collectionURL.pathname){u.searchParams.set('nt_stock','1');a.href=u.href;}});
    window.addEventListener('popstate',function(){location.reload();});
    selects.forEach(function(s){s.disabled=true;});apply.disabled=true;form.setAttribute('aria-busy','true');
    var optionStatus=document.createElement('span');optionStatus.setAttribute('role','status');optionStatus.textContent=config.loading;form.appendChild(optionStatus);
    loadOptions().then(function(){optionStatus.remove();}).catch(function(){optionStatus.textContent=config.error;var retry=document.createElement('button');retry.type='button';retry.textContent=config.retry;retry.addEventListener('click',function(){location.reload();});optionStatus.appendChild(retry);});
    updateResults();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
